import React from "react";
import styles from "../Transcript.module.css";

export default function DisplayControlBar({
  displaySettings,
  setDisplaySettings,
  onClose,
}) {
  // 학기 목록 정의 (9-12학년, Spring/Fall)
  const semesters = [
    { grade: 9, term: 1, label: "Spring 9th", key: "9-1" },
    { grade: 9, term: 2, label: "Fall 9th", key: "9-2" },
    { grade: 10, term: 1, label: "Spring 10th", key: "10-1" },
    { grade: 10, term: 2, label: "Fall 10th", key: "10-2" },
    { grade: 11, term: 1, label: "Spring 11th", key: "11-1" },
    { grade: 11, term: 2, label: "Fall 11th", key: "11-2" },
    { grade: 12, term: 1, label: "Spring 12th", key: "12-1" },
    { grade: 12, term: 2, label: "Fall 12th", key: "12-2" },
  ];

  const handleVisibleChange = (key) => {
    setDisplaySettings((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        visible: !prev[key].visible,
      },
    }));
  };

  const handleCourseTitleOnlyChange = (key) => {
    setDisplaySettings((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        courseTitleOnly: !prev[key].courseTitleOnly,
      },
    }));
  };

  const handleAllVisible = () => {
    const allVisible = semesters.every(
      (sem) => displaySettings[sem.key]?.visible
    );
    const newSettings = { ...displaySettings };
    semesters.forEach((sem) => {
      newSettings[sem.key] = {
        ...newSettings[sem.key],
        visible: !allVisible,
      };
    });
    setDisplaySettings(newSettings);
  };

  const handleAllCourseTitleOnly = () => {
    const allCourseTitleOnly = semesters.every(
      (sem) => displaySettings[sem.key]?.courseTitleOnly
    );
    const newSettings = { ...displaySettings };
    semesters.forEach((sem) => {
      newSettings[sem.key] = {
        ...newSettings[sem.key],
        courseTitleOnly: !allCourseTitleOnly,
      };
    });
    setDisplaySettings(newSettings);
  };

  return (
    <div className={styles.displayControlBar}>
      <div className={styles.controlBarHeader}>
        <table className={styles.controlTable}>
          <thead>
            <tr>
              <th>Grade</th>
              {semesters.map((sem) => (
                <th key={sem.key}>{sem.label}</th>
              ))}
              <th>All</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.controlLabel}>Visible</td>
              {semesters.map((sem) => (
                <td key={sem.key} className={styles.checkboxCell}>
                  <input
                    type="checkbox"
                    checked={displaySettings[sem.key]?.visible ?? true}
                    onChange={() => handleVisibleChange(sem.key)}
                  />
                </td>
              ))}
              <td className={styles.checkboxCell}>
                <input
                  type="checkbox"
                  checked={semesters.every(
                    (sem) => displaySettings[sem.key]?.visible
                  )}
                  onChange={handleAllVisible}
                />
              </td>
            </tr>
            <tr>
              <td className={styles.controlLabel}>Course Title Only</td>
              {semesters.map((sem) => (
                <td key={sem.key} className={styles.checkboxCell}>
                  <input
                    type="checkbox"
                    checked={displaySettings[sem.key]?.courseTitleOnly ?? false}
                    onChange={() => handleCourseTitleOnlyChange(sem.key)}
                  />
                </td>
              ))}
              <td className={styles.checkboxCell}>
                <input
                  type="checkbox"
                  checked={semesters.every(
                    (sem) => displaySettings[sem.key]?.courseTitleOnly
                  )}
                  onChange={handleAllCourseTitleOnly}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {onClose && (
          <div className={styles.closeButtonWrapper}>
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              aria-label="닫기"
            >
              ×
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
